import React from "react";
import { Button, Spinner } from "@lemonadetraining/web-ui";
import type { CardUpdateRedirect } from "../../hooks/useCardUpdateRedirect";
import CardUpdateError from "./CardUpdateError";
import { UPDATE_PAYMENT_LABEL } from "./dunningCopy";

interface CardUpdateButtonProps {
  cardUpdate: CardUpdateRedirect;
  variant?: React.ComponentProps<typeof Button>["variant"];
  className?: string;
  testId: string;
  showError?: boolean;
}

const CardUpdateButton: React.FC<CardUpdateButtonProps> = ({
  cardUpdate,
  variant,
  className,
  testId,
  showError = true,
}) => {
  const busy = cardUpdate.status === "minting";
  return (
    <>
      <Button
        type="button"
        variant={variant}
        className={className}
        onClick={cardUpdate.start}
        disabled={busy}
        aria-busy={busy}
        data-testid={testId}
      >
        {busy && <Spinner className="h-4 w-4" />}
        {UPDATE_PAYMENT_LABEL}
      </Button>
      {showError && cardUpdate.errorMessage ? (
        <CardUpdateError message={cardUpdate.errorMessage} onRetry={cardUpdate.start} busy={busy} />
      ) : null}
    </>
  );
};

export default CardUpdateButton;
